export const MATERIAL_COLORS = {
  'light-blue': '#03A9F4',
  'deep-purple': '#673AB7',
  'blue-darken-3': '#1565C0',
}

export const DATA_VISUALISATION_COLORS = {
  'Purple-200': '#E5BFFF',
  'Lime-200': '#9DDD6E',
  'Indigo-200': '#B1B1FF',
  'Peach-200': '#FFD5BE',
  'Pink-200': '#FFC5FF',
  'Green-200': '#A1E3D2',
  'Gold-200': '#FFE7AD',
  'Grey-200': '#D4D7DA',
}

export function hexToRGB (hexColor) {
  const result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hexColor)
  return result
? {
    r: parseInt(result[1], 16),
    g: parseInt(result[2], 16),
    b: parseInt(result[3], 16),
  }
: null
}

export const DARK_BLUE_50 = '#E9F1FE'
export const DARK_BLUE_500 = '#2671F2'
export const DARK_BLUE_DARKEST = '#00172E'
